import { Link } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link as Scroll } from "react-scroll";

import "../styling/ForFitnessProf.scss";
import ActiveCampaignForm from "../components/ActiveCampaignForms/ActiveCampaignForm";

import weights from "../assets/forFitnessPage/trainerWeightsIcon.png";
import community from "../assets/forFitnessPage/communityIcon.png";
import bestRates from "../assets/forFitnessPage/bestRatesIcon.png";

import workbookIcon from "../assets/forFitnessPage/workbookIcon.png";
import contentIcon from "../assets/forFitnessPage/contentIcon.png";
import blogIcon from "../assets/forFitnessPage/blogIcon.png"

import dylan from "../assets/dylanTestimonial.mp4"

//Hero Image
import video from "../assets/heroImages/pltfrmHero2.mp4";

const ForFitnessProf =()=>{
    const location = useLocation();
    const elementRef = useRef(null);

    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(
        function () {
            if (location.pathname === "/forfitnessprofessionals") {
                elementRef.current.scrollIntoView({
                    behavior: "smooth",
                });
            }
            setHasLoaded(true)
        },
        [location]);

    return (
        <>
            {/* <NavBar /> */}
            <div className="forFitnessProfPage" ref={elementRef}>
                <header className="forFitnessHeader">
                    <video
                        src={video}
                        autoPlay
                        muted
                        loop
                        playsInline
                        type="video/mp4"
                        id="myVideo"
                    ></video>
                    <div className="fitnessHeaderContent">
                        <div className="wrapper">
                            <div className="forFitnessHeader">
                                <h1>
                                    A Private Training Gym for Fitness
                                    Professionals
                                </h1>
                                <p>
                                    Toronto’s premium space to train, connect, &
                                    grow your businesses
                                </p>
                                <div className="buttonContainer">
                                    <button>
                                        <a href="https://calendly.com/pltfrm-fit/30mintour">
                                            BOOK A TOUR
                                        </a>
                                    </button>

                                    <button>
                                        <Scroll to="memberships" smooth={true}>
                                            MEMBERSHIPS
                                        </Scroll>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <section className="designedFor">
                    <div className="wrapper">
                        <div>
                            <img src={weights} alt="" />
                            <h2>Designed for trainers</h2>
                            <p>
                                We have a top quality facility with all the
                                equipment you need to give your clients a
                                premium experience. Our alcoves are designed for
                                privacy.
                            </p>
                        </div>
                        <div>
                            <img src={community} alt="" />
                            <h2>Fitness community</h2>
                            <p>
                                Our goal is to be a hub for independent fitness
                                professionals. We are always looking to host
                                events and meetups for our community focused on
                                your business growth.
                            </p>
                        </div>
                        <div>
                            <img src={bestRates} alt="" />
                            <h2>Best rates in the city</h2>
                            <p>
                                PLTFRM is proud to say that we have some of the
                                best hourly rates in the city for a private
                                training gym. This makes it easy for you to
                                scale your business & your income.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="whatOthersSay">
                    <div className="wrapper">
                        <div className="trainerContainer">
                            <div>
                                <h2>
                                    Don’t just take our word for it, listen to
                                    what our trainers have to say about{" "}
                                    <span className="titleImportant">
                                        PLTFRM
                                    </span>
                                </h2>
                                <video
                                    src={dylan}
                                    controls
                                    playsInline
                                    type="video/mp4"
                                ></video>
                            </div>
                            <div className="mailingListContainer">
                                <h2>Join Our Mailing List</h2>
                                <p>
                                    Be the first to hear about events and
                                    offers.
                                </p>
                                <ActiveCampaignForm form={hasLoaded} />
                            </div>
                        </div>
                        <div className="buttonContainer">
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    BOOK A TOUR
                                </a>
                            </button>
                        </div>
                    </div>
                </section>
                <section className="ourMemberships">
                    <div className="wrapper">
                        <h2>Our memberships</h2>
                        <p>
                            Our memberships are designed to help you grow and
                            scale your business. Our membership gets you access
                            to training hours.
                        </p>
                        <div className="membershipContainer" name="memberships">
                            <div className="memberOption">
                                <div className="membershipInfo">
                                    <h4>BEGINNER FITNESS PROFESSIONAL</h4>
                                    <h2>Basic</h2>
                                    <ul>
                                        <li>8 training hours/month</li>
                                        <li>24/7 PLTFRM access</li>
                                        <li>
                                            Coworking spaces & content equipment
                                            access.
                                        </li>
                                        <li>
                                            Trainer profile and client
                                            referrals.
                                        </li>
                                        <li>
                                            Additional training hours are
                                            $37/per session
                                        </li>
                                        <li>
                                            Book the entire top gym space for a
                                            group class for $55/hour
                                        </li>
                                    </ul>
                                    <h3>
                                        $149 <span>per month + tax</span>
                                    </h3>
                                </div>
                                <div className="buttonContainer">
                                    <button>
                                        <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=9&k_id=3705665">
                                            JOIN
                                        </a>
                                    </button>
                                </div>
                            </div>
                            <div className="memberOption mostPopular">
                                <h4 className="mostPopularTitle">
                                    MOST POPULAR
                                </h4>
                                <div className="membershipInfo">
                                    <h4>ALL-IN FITNESS PROFESSIONAL</h4>
                                    <h2>Premium</h2>
                                    <ul>
                                        <li>Unlimited Training Hours</li>
                                        <li>24/7 PLTFRM access</li>
                                        <li>
                                            Coworking spaces & content equipment
                                            access.
                                        </li>
                                        <li>
                                            Trainer profile and client
                                            referrals.
                                        </li>
                                        <li>
                                            Book the entire top gym space for a
                                            group class for a{" "}
                                            <strong>
                                                discounted rate of $28/hour
                                            </strong>
                                            , normally $55/hour
                                        </li>
                                    </ul>
                                    <h3>
                                        $299 <span>per month + tax</span>
                                    </h3>
                                </div>
                                <div className="buttonContainer">
                                    <button>
                                        <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=5&k_id=3705654">
                                            JOIN
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <h4>
                            PICK THE MEMBERSHIPS THAT FITS YOUR GOALS! <br />A
                            TRAINING SESSION IS 1 HOUR!
                        </h4>
                    </div>
                </section>
                <section className="bookATour">
                    <div className="wrapper">
                        <p>
                            Can’t find a membership that works for you? Contact
                            our team to discuss a custom package. We offer
                            single training sessions for $37/hour
                        </p>
                        <div className="bookATourButtonContainer">
                            <h2>Book a tour</h2>
                            <p>
                                Ready to find out if PLTFRM is your home? Book a
                                tour and let’s chat about what we can do for
                                you!
                            </p>
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    BOOK A TOUR
                                </a>
                            </button>
                        </div>
                    </div>
                </section>
                <section className="haveAQuestion forFitnessHaveAQ">
                    <div className="wrapper">
                        <h2>
                            Have a question? Checkout our{" "}
                            <Link to="/faq">FAQ</Link>
                        </h2>
                    </div>
                </section>
                <section className="resources">
                    <div className="wrapper">
                        <h2>RESOURCES FOR FITNESS PROFESSIONALS</h2>
                        <p>
                            Ready to find out if PLTFRM is your home? Get in
                            touch with us and let’s chat about what we can do
                            for you!
                        </p>
                        <div className="resourceContainer">
                            <div>
                                <Link to="/blog">
                                    <img src={blogIcon} alt="Link to Blog" />
                                    <span className="sr-only sr-only-focusable">
                                        Link to PLTFRM.fit Blog
                                    </span>
                                </Link>
                                <h4>BLOG FOR FITNESS PROFESSIONALS</h4>
                                <p>
                                    This is your stop for short and potent
                                    articles that can help you grow your
                                    business and stay on top of trends in the
                                    fitness industry.
                                </p>
                            </div>
                            <div>
                                <Link to="/forfitnessprofessionals/contentguide">
                                    <img
                                        src={contentIcon}
                                        alt="Link to PLTFRM's Content Guide"
                                    />
                                    <span className="sr-only sr-only-focusable">
                                        Link to book a tour at our location.
                                    </span>
                                </Link>
                                <h4>CONTENT CREATION GUIDE</h4>
                                <p>
                                    This includes ideas for content, templates,
                                    and a 1 month content calendar. Everything
                                    you need to kickstart your content.
                                </p>
                            </div>
                            <div>
                                <Link to="/forfitnessprofessionals/workbook">
                                    <img
                                        src={workbookIcon}
                                        alt="Link to PLTFRM's workbook"
                                    />
                                    <span className="sr-only sr-only-focusable">
                                        Link to send marketing@pltfrm.fit an
                                        email
                                    </span>
                                </Link>
                                <h4>101 PERSONAL TRAINING WORKBOOK</h4>
                                <p>
                                    This workbook includes everything you need
                                    to know about starting a personal training
                                    business in Toronto.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default ForFitnessProf;